<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>
<template lang="html">
  <div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$tc('Labels.TankLevel',0)}}</label>
        <vs-slider v-model="filters.level_tank"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <vs-checkbox v-model="filterLastCharge" class="inline-block"></vs-checkbox>
        <label class="font-bold">{{$t('Labels.LastCharge')}}</label>
        <datepicker :value="filters.recharge_at" format="dd-MM-yyyy" :disabled="!filterLastCharge"></datepicker>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.ClientNumber')}}</label>
        <vs-input class="w-full" v-model="filters.client_number" />
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="getResponse()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Capacity')}}</label>
        <vs-slider v-model="filters.capacity"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <vs-checkbox v-model="filterLastSeen" class="inline-block"></vs-checkbox>
        <label class="font-bold">{{$t('Labels.LastSeen')}}</label>
        <datepicker :value="filters.last_seen" format="dd-MM-yyyy" :disabled="!filterLastSeen"></datepicker>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Serie')}}</label>
        <vs-input class="w-full" v-model="filters.serie" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.BatteryLevel')}}</label>
        <vs-slider v-model="filters.battery"/>
      </div>
      <div class="vx-col w-full text-center sm:hidden">
        <vs-button @click="getResponse()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>  
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0"> 
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"/>
      </div>
    </div>
    <vs-table  v-if="response" :data="response"  v-model="selected" @selected="goToDetail">
      <template slot="thead">
        <vs-th>
          {{$tc('Labels.TankLevel',1)}}
        </vs-th>
        <vs-th>
          {{$t('Labels.Liters')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.Serie')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.ClientNumber')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.Battery')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.LastCharge')}}
        </vs-th>
        <vs-th>
          {{$t('Labels.LastSeen')}}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="item" :key="index" @click="goToDetail(item.uuid)" v-for="(item, index) in data" :class="{'inactive': !item.updatedAt }">
          <vs-td :data="parseInt(item.percent)">
            <statusItem :status="item.updatedAt.length > 0 ? getStatus(item.percent) : 'grey'" :percent="item.percent"/>
          </vs-td>
          <vs-td :data="getLiters(item.percent,item.capacity)">
            {{getLiters(item.percent,item.capacity)}} / {{item.capacity}}
          </vs-td>
          <vs-td :data="item.serie">
            {{item.serie}}
          </vs-td>
          <vs-td :data="item.client_number">
            {{item.updatedAt.length > 0 ? item.client_number : 'N/A'}}
          </vs-td>
          <vs-td :data="item.battery" >
            <icon-battery-percent class="align-middle" width="25" height="25" iconColor="#000" :percent="parseFloat(item.battery)" /> <span class="align-middle">{{item.battery}} %</span>
          </vs-td>
          <vs-td :data="item.recharge_at">
            <!--{{item.recharge_at}}-->
            {{item.deveui}}
          </vs-td>
          <vs-td :data="item.updatedAt">
            <!--<span>{{item.updatedAt.length > 0 ? relativeTimeConvert(item.updatedAt) : $t('Labels.Inactive')}}</span>-->
            {{item.updatedAt}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination class="mt-5" v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {app} from './../../../main' 
import {getStatusByPercent, formatDate, empty} from '@/helpers.js'
import listItem from '@/components/listItem/listItem.vue'
import listAlertItem from '@/components/listAlertItem/listAlertItem.vue'
import statusItem from '@/components/statusItem/statusItem.vue'
import iconBatteryPercent from '@/components/icons/iconBatteryPercent'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'


export default {
  components: {
    listItem,
    listAlertItem,
    statusItem,
    iconBatteryPercent,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      selected:[],
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'updatedAt',
        byOrder: 'ASC',
        serie:null,
        client_number: null,
        level_tank: this.$route.query.begin_percent !== undefined && this.$route.query.end_percent !== undefined ? [this.$route.query.begin_percent, this.$route.query.end_percent] : [null, null],
        battery: this.$route.query.begin_battery !== undefined && this.$route.query.end_battery !== undefined ? [this.$route.query.begin_battery, this.$route.query.end_battery] : [null, null],
        capacity: [null, null],
        last_seen: new Date(),
        recharge_at: new Date(),
        begin_last_seen: this.$route.query.begin_last_seen !== undefined ? this.$route.query.begin_last_seen : null,
        end_last_seen: this.$route.query.end_last_seen !== undefined ? this.$route.query.end_last_seen : null,
        status_device: this.$route.query.status_device !== undefined ? this.$route.query.status_device : null
      },
      filterLastCharge: false,
      filterLastSeen: false,
      filterBeginEndLastSeen: true,
      columnOrders:[
        {label: this.$tc('Labels.TankLevel', 1), value: 'percent'},
        {label: this.$t('Labels.ClientNumber'), value: 'client_number'},
        {label: this.$t('Labels.Battery'), value: 'battery'},
        {label: this.$t('Labels.LastCharge'), value: 'recharge_at'},
        {label: this.$t('Labels.LastSeen'), value: 'updatedAt'}
      ],
      byColumn: 'updatedAt',
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const filter = {}
      filter.begin_battery = this.filters.battery[0]
      filter.end_battery = this.filters.battery[1]
      if (this.filters.battery[1] !== null && this.filters.battery[0] === null) filter.begin_battery = 0
      filter.begin_percent = this.filters.level_tank[0]
      filter.end_percent = this.filters.level_tank[1]
      if (this.filters.level_tank[1] !== null && this.filters.level_tank[0] === null) filter.begin_percent = 0
      filter.begin_capacity = this.filters.capacity[0]
      filter.end_capacity = this.filters.capacity[1]
      if (this.filters.capacity[1] !== null && this.filters.capacity[0] === null) filter.begin_capacity = 0
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder
      filter.serie = this.filters.serie
      filter.client_number = this.filters.client_number

      if (this.filterBeginEndLastSeen) {
        filter.begin_last_seen = this.filters.begin_last_seen
        filter.end_last_seen = this.filters.end_last_seen
        filter.status_device = this.filters.status_device
      }
        
      
      if (this.filterLastCharge) filter.recharge_at = formatDate(this.filters.recharge_at)
      
      if (this.filterLastSeen) filter.last_seen = formatDate(this.filters.last_seen)
      
      const params = {
        url: 'gas_devices',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        if (response.data.data.rows.length === 1) { 
          app.$router.push(`/gas/${response.data.data.rows[0].uuid}`)
          return false
        }
        this.setPages(response.data.data.count)
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
        this.filterBeginEndLastSeen = false
      })
      
    },
    resetFilters () {
      this.filters.serie = null
      this.filters.client_number = null
      this.filters.level_tank = [null, null]
      this.filters.battery = [null, null]
      this.filters.capacity = [null, null]
      this.filters.last_seen = new Date()
      this.filters.recharge_at = new Date()
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    getStatus (percent) {
      return getStatusByPercent(percent)
    },
    getLiters (percent, capacity) {
      return (capacity * (percent / 100)).toFixed(2)
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    goToDetail (tr) {
      if (!empty(tr.uuid)) window.location.href = `/gas/${tr.uuid}`
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    }

  },
  sockets: {
    gas (payload) {
      this.response.forEach(toModify => {
        if (toModify.deveui === payload.deveui) {
          toModify.rssi = payload.rssi
          toModify.battery = payload.battery
          toModify.percent = payload.percent
          toModify.updatedAt = payload.updated_at
        }
      })
    }
  },
  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.getResponse()
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>